import {useTheme} from '@mui/material';
import Box from '@mui/material/Box';
import {bool} from 'prop-types';

const ActiveSidebarElementIndicator = ({isVisible}) => {
  const theme = useTheme();

  return (
    <Box
      role="presentation"
      width={0}
      height="100%"
      sx={{borderTopRightRadius: 5, borderBottomRightRadius: 5}}
      borderRight={isVisible ? `4px solid ${theme.palette.primary.main}` : '4px solid transparent'}
    />
  );
};

ActiveSidebarElementIndicator.propTypes = {
  isVisible: bool.isRequired
};

export default ActiveSidebarElementIndicator;
